import React from 'react';
import { RefreshCcw } from 'lucide-react';
import {
  SidebarProvider,
  SidebarTrigger,
  SidebarInset,
  Button
} from '../ui';
import AppSidebar from './AppSidebar';
import ImpersonationBanner from './ImpersonationBanner';

const mobileSafeAreaTop = {
  paddingTop: 'max(0.75rem, env(safe-area-inset-top))'
};
const mobileHeaderSpacing = {
  paddingBottom: '0.75rem'
};

const SiteHeader = ({ title, subtitle, refreshAction }) => {
  const [refreshing, setRefreshing] = React.useState(false);

  const handleRefresh = async () => {
    if (!refreshAction || refreshing) return;
    setRefreshing(true);
    try {
      await refreshAction();
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <header
      className="flex min-h-12 shrink-0 items-center gap-2 border-b bg-background md:pt-0 md:pb-0"
      style={{ ...mobileSafeAreaTop, ...mobileHeaderSpacing }}
    >
      <div className="flex items-center gap-2 px-4">
        <SidebarTrigger />
      </div>
      <div className="flex flex-col flex-1 min-w-0 px-4">
        {title && <h1 className="text-lg font-semibold truncate">{title}</h1>}
        {subtitle && (
          <p className="text-sm text-muted-foreground hidden md:block truncate">{subtitle}</p>
        )}
      </div>
      {/* refreshAction se recibia y se descartaba: 15 pantallas pasaban una funcion
          de refresco que no hacia nada. Aqui es donde tiene sentido, junto al titulo. */}
      {refreshAction && (
        <div className="px-4 shrink-0">
          <Button
            variant="ghost"
            size="sm"
            className="h-9 w-9 p-0"
            onClick={handleRefresh}
            disabled={refreshing}
            aria-label="Actualizar"
            title="Actualizar"
          >
            <RefreshCcw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
          </Button>
        </div>
      )}
    </header>
  );
};

const FeaturedLayout = ({ children, title, subtitle, refreshAction }) => {
  return (
    <SidebarProvider>
      <div className="flex h-screen w-full overflow-hidden">
        <AppSidebar />
        <SidebarInset className="flex-1 min-w-0 overflow-hidden">
          <ImpersonationBanner />
          <SiteHeader title={title} subtitle={subtitle} refreshAction={refreshAction} />
          <div className="flex-1 overflow-y-auto">
            <div className="container mx-auto p-4 lg:p-6 max-w-full overflow-x-hidden">
              {children}
            </div>
          </div>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default FeaturedLayout;
